export const previewCardImageHeight = 115;
export const previewCardImageWidth = 260;
